import { BaseStore } from 'fluxible/addons';

class SelectedWinnersStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.entries = [];
    }

    initialise(state) {
        this.entries = state.entries;
        this.persistWinnerShortlistUrl = state.persistWinnerShortlistUrl;
        this.showDrawer = state.showDrawer;
        this.maxMultipleWinners = state.maxMultipleWinners;
        this.additionalWinnerCostsPreTax = state.additionalWinnerCostsPreTax;
        this.additionalWinnerCostTaxAmounts = state.additionalWinnerCostTaxAmounts;
        this.additionalWinnerCostTotals = state.additionalWinnerCostTotals;
        this.additionalWinnerSavings = state.additionalWinnerSavings;
        this.paymentDataEndpoint = state.paymentDataEndpoint;
        this.emitChange();
    }

    addWinner(entry) {
        if (!this.isWinner(entry.designId)) {
            this.entries = [...this.entries, entry];
            this.emitChange();
        }
    }

    isWinner(designId) {
        return this.entries.some(entry => entry.designId === designId);
    }

    removeWinner(designId) {
        this.entries = this.entries.filter(entry => entry.designId !== designId);
        this.emitChange();
    }

    getEntries() {
        return this.entries;
    }

    getEntry(designId) {
        return this.entries.find(entry => entry.designId === designId);
    }

    getPersistWinnerShortlistUrl() {
        return this.persistWinnerShortlistUrl;
    }

    getShowDrawer() {
        return this.showDrawer || !!this.entries.length;
    }

    setShowDrawer() {
        this.showDrawer = true;
        this.emitChange();
    }

    hasSelectedMaxWinners() {
        return this.entries.length >= this.maxMultipleWinners;
    }

    getPreTaxPriceForAdditionalWinners() {
        const winnerCount = this.entries.length;
        if (winnerCount === 1 || winnerCount === 0) {
            return '';
        }
        if (this.additionalWinnerCostsPreTax[winnerCount] !== undefined) {
            return this.additionalWinnerCostsPreTax[winnerCount];
        }
        throw new Error(`Price for ${winnerCount} winners not provided.`);
    }

    getTotalForAdditionalWinners() {
        const winnerCount = this.entries.length;
        if (winnerCount === 1 || winnerCount === 0) {
            return '';
        }
        if (this.additionalWinnerCostTotals[winnerCount] !== undefined) {
            return this.additionalWinnerCostTotals[winnerCount];
        }

        throw new Error(`Total for ${winnerCount} winners not provided.`);
    }

    getTaxAmountForAdditionalWinners() {
        const winnerCount = this.entries.length;
        if (winnerCount === 1 || winnerCount === 0) {
            return '';
        }
        if (this.additionalWinnerCostTaxAmounts[winnerCount] !== undefined) {
            return this.additionalWinnerCostTaxAmounts[winnerCount];
        }
        throw new Error(`Price for ${winnerCount} winners not provided.`);
    }

    getSavingsForAdditionalWinners() {
        const winnerCount = this.entries.length;
        if (winnerCount === 1 || winnerCount === 0) {
            return '';
        }
        if (this.additionalWinnerSavings[winnerCount] !== undefined) {
            return this.additionalWinnerSavings[winnerCount];
        }
        throw new Error(`Saving for ${winnerCount} winners not provided.`);
    }

    getPaymentDataEndpoint() {
        return this.paymentDataEndpoint;
    }
}

SelectedWinnersStore.storeName = 'SelectedWinnersStore';

SelectedWinnersStore.handlers = {
    ADD_WINNER: 'addWinner',
    ADD_WINNER_ERROR: 'removeWinner',
    REMOVE_WINNER: 'removeWinner',
    REMOVE_WINNER_ERROR: 'addWinner',
    SHOW_DRAWER: 'setShowDrawer',
};

export default SelectedWinnersStore;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/stores/selected-winners-store.js